module.exports = __webpack_public_path__ + "img/placeholder.01d0537e.jpg";